import { after, between } from '../engine';
import { burst, explode, glints, rain, shock, wash } from '../kit';
import { paper } from '../shapes';
import { UP, type Preset } from './types';

/**
 * Daily words (每日成语): a solved puzzle — paper letter tiles fly up from the field with soft ink-blue glints, no
 * fireworks of money (a solved puzzle is not a win of tokens). big / mega exist for the shared contract (a contest
 * prize shown by the history): a calm rain of tiles, then ink bursts.
 */
const INK = ['#2EE6C9', '#5B7CFA', '#B08CFF', '#FFD166', '#F3EAD6'] as const;

export const words: Preset = {
  pal: INK,
  light: '#FFFFFF',
  win(s) {
    burst(s, s.x, s.y, {
      n: 28,
      speed: [160, 340],
      angle: UP,
      spread: 1.4,
      draw: paper,
      cols: INK,
      size: [5, 8],
      life: [0.7, 0.9],
      gravity: 560,
      drag: 0.5,
      flip: [4, 8],
      vr: [-4, 4],
    });
    shock(s.x, s.y, { col: '#5B7CFA', r: 70, dur: 0.6, width: 2 });
    glints(s, s.x, s.y, 6, 26, ['#FFFFFF', '#2EE6C9']);
  },
  big(s) {
    wash(s.W / 2, s.H * 0.45, { col: '#5B7CFA', r: Math.max(s.W, s.H) * 0.5, dur: 1.6, alpha: 0.25 });
    rain(s, {
      n: 140,
      over: 1300,
      vy: [110, 220],
      draw: paper,
      cols: INK,
      size: [6, 9],
      life: [2, 2.4],
      sway: [12, 26],
      flip: [3, 7],
      vr: [-2, 2],
      gravity: 70,
    });
    words.win(s);
  },
  mega(s) {
    words.big(s);
    after(900, () => {
      for (let i = 0; i < 3; i++)
        explode(s, s.W * (0.3 + 0.2 * i), s.H * between(0.25, 0.4), {
          col: INK[i % INK.length]!,
          n: 80,
          speed: 380,
          ring: true,
        });
    });
  },
};
